import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import { AppSettings } from '../../config/app-settings.js';
import { toast } from 'react-toastify';

function Home({ props = {} }) {
	const context = useContext(AppSettings);

	useEffect(() => {

	})

	const notify = () => toast.info('🦄 Wow so easy! easy peacy easy peacy easy peacy easy peacy easy peacy', {
		// position: "top-right",
		// autoClose: 3000,
		// hideProgressBar: true,
		// closeOnClick: true,
		// pauseOnHover: true,
		// draggable: true,
		// progress: undefined,
		// theme: "colored",
		// transition: Bounce,
	});;

	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/page-option/blank">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/page-option/blank">Page Options</Link></li>
				<li className="breadcrumb-item active">Blank Page</li>
			</ol>
			<h1 className="page-header">Home <small>header small text goes here...</small></h1>
			<Panel>
				<PanelHeader>Panel Title here</PanelHeader>
				<PanelBody>
				 
				</PanelBody>
			</Panel>
		</div>
	)
}

export default Home;